import { BannerButton, VisibleBannerVariant } from '../types';
import GuidedTourBanner from './ui/GuidedTourBanner';
import OfferCheckoutBanner from './ui/OfferCheckoutBanner';
import PausedBanner from './ui/PausedBanner';

const TALKING_MASCOT_SRC = 'https://zoolife.tv/assets/guidedTour/mascot/crop-talk.webp';
const IDLE_MASCOT_SRC = 'https://zoolife.tv/assets/guidedTour/mascot/crop-idle.webp';
const PAUSED_MASCOT_SRC = 'https://zoolife.tv/assets/guidedTour/mascot/crop-sleep.webp';

interface TourBannerSlotProps {
  /** The already-resolved variant for the current path. */
  banner: VisibleBannerVariant;
  onButtonClick: (button: BannerButton) => void;
}

/**
 * Renders banner content only. No controller, no arbitration, no path resolution — the runner
 * has already decided which variant applies; this just draws it.
 */
const TourBannerSlot = ({ banner, onButtonClick }: TourBannerSlotProps) => {
  const toClickable = (btn: BannerButton) => ({ label: btn.label, onClick: () => onButtonClick(btn) });

  if (banner.type === 'paused') {
    return (
      <PausedBanner
        currentSection={banner.currentSection}
        nextHabitat={banner.nextHabitat}
        mascotSrc={PAUSED_MASCOT_SRC}
        buttons={(banner.buttons ?? []).map(toClickable)}
      />
    );
  }

  if (banner.type === 'offer-checkout') {
    return (
      <OfferCheckoutBanner
        speechBubble={banner.speechBubble}
        buttonLabel={banner.buttonLabel}
        offerId={banner.offerId}
        mascotSrc={banner.mascot === 'idle' ? IDLE_MASCOT_SRC : TALKING_MASCOT_SRC}
        onButtonClick={onButtonClick}
      />
    );
  }

  const { backButton, breakButton } = banner;
  return (
    <GuidedTourBanner
      message={banner.speechBubble}
      mascotSrc={banner.mascot === 'idle' ? IDLE_MASCOT_SRC : TALKING_MASCOT_SRC}
      buttons={(banner.buttons ?? []).map(toClickable)}
      goBackLabel={backButton?.label}
      onGoBack={backButton ? () => onButtonClick(backButton) : undefined}
      takeABreakLabel={breakButton?.label}
      onTakeABreak={breakButton ? () => onButtonClick(breakButton) : undefined}
    />
  );
};

export default TourBannerSlot;
